<template>
  <div />
</template>

<script>
export default {
  mounted() {
    location.replace("https://support.path.net");
  },
};
</script>
